// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-main {
  flex: 999 1 600px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.site-card {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.site-url-row {
  display: flex;
  gap: 10px;
}
.site-url-row input {
  flex: 1;
  min-width: 0;
}
.site-scan {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 6px 0;
}
.site-fail {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #7f1d1d;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.site-head {
  display: flex;
  gap: 12px;
  align-items: center;
}
.site-ok {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--v2-green-text);
}
.site-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.site-stats > div {
  background: var(--v2-bg);
  border-radius: 10px;
  padding: 10px 12px;
}
.site-stats b {
  font-size: 18px;
}
.site-note {
  background: var(--v2-orange-bg);
  color: #7c2d12;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
}
.site-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 4px;
}
.site-list {
  margin: 0;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  color: var(--v2-text-2);
}
.site-hero {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 18px;
}
.site-pages-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  padding: 14px 16px 8px;
}
.site-side {
  flex: 1 1 320px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.site-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #d1d5db;
  margin-right: 4px;
}
.site-dot.is-ok {
  background: var(--v2-green);
}
.site-dot.is-blue {
  background: var(--v2-blue);
}
.site-side > .kb-aside {
  flex: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/knowledge/site.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ","sourcesContent":[".site-main {\n  flex: 999 1 600px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.site-card {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.site-url-row {\n  display: flex;\n  gap: 10px;\n}\n.site-url-row input {\n  flex: 1;\n  min-width: 0;\n}\n.site-scan {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 6px 0;\n}\n.site-fail {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #7f1d1d;\n  border-radius: 12px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.site-head {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n.site-ok {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--v2-green-text);\n}\n.site-stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n.site-stats > div {\n  background: var(--v2-bg);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n.site-stats b {\n  font-size: 18px;\n}\n.site-note {\n  background: var(--v2-orange-bg);\n  color: #7c2d12;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n.site-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 4px;\n}\n.site-list {\n  margin: 0;\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--v2-text-2);\n}\n.site-hero {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 18px;\n}\n.site-pages-head {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n  padding: 14px 16px 8px;\n}\n.site-side {\n  flex: 1 1 320px;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.site-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #d1d5db;\n  margin-right: 4px;\n}\n.site-dot.is-ok {\n  background: var(--v2-green);\n}\n.site-dot.is-blue {\n  background: var(--v2-blue);\n}\n.site-side > .kb-aside {\n  flex: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
